import React, { FunctionComponent, ReactNode } from 'react';
import PlaceholderFallback from 'src/ui/atoms/placeholder-fallback';
import Spacer from '../spacer';
import * as Styled from './styled';

export interface CardItemProps {
  title: string | ReactNode;
  content?: string | ReactNode;
  icon?: string | ReactNode;
}

export const CardItem: FunctionComponent<CardItemProps> = (props) => {
  const { title, content, icon } = props;

  return (
    <Styled.CardItem spacing="medium">
      <Styled.Title>{title}</Styled.Title>
      <Styled.ContentContainer>
        <PlaceholderFallback>
          {content && (
            <Styled.Content>
              <Styled.TruncatedText>{content}</Styled.TruncatedText>
              {icon && (
                <>
                  <Spacer x={1} />
                  {icon}
                </>
              )}
            </Styled.Content>
          )}
        </PlaceholderFallback>
      </Styled.ContentContainer>
    </Styled.CardItem>
  );
};

export default CardItem;
